import styled, { keyframes } from "styled-components";
import NumberFormat from "react-number-format";
import { fadeInRight } from "react-animations";

// Keyframes
const fadeInRightAnimation = keyframes`${fadeInRight}`;

export const PathologyDiv = styled.div`
  width: 100%;
  max-width: 860px;
  margin: 10px 0;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 910px) {
    width: auto;
  }
`;
export const InputDataDiv = styled.div`
  width: ${({ width }) => width && width};
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  animation: ${({ activeAnimation }) => activeAnimation && fadeInRightAnimation};
  animation-duration: 0.3s;
  @media (max-width: 910px) {
    width: auto;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
  text-align: right;
`;
export const DateInput = styled(NumberFormat)`
  padding: 5px 10px;
  width: 200px;
  border: ${({ border }) => border && border};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  animation: 0.3s ${fadeInRightAnimation};
`;
